<app-pageheader [Parent]="this">
  <form-edit-button>Edit</form-edit-button>
</app-pageheader>

<app-loader [Parent]="this"></app-loader>

@if (Model) {
  <div>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Citation Template Details
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name">
              <div class="control">
                <p class="input">{{Model.Name}}</p>
              </div>
            </app-field>
            <app-field Label="Description">
              <div class="control">
                <p class="input">{{Model.Description || 'No description provided'}}</p>
              </div>
            </app-field>
            <app-field Label="Feed Lines Before Print">
              <div class="control">
                <p class="input">{{Model.FeedLinesBeforePrint}}</p>
              </div>
            </app-field>
            <app-field Label="Feed Lines After Print">
              <div class="control">
                <p class="input">{{Model.FeedLinesAfterPrint}}</p>
              </div>
            </app-field>
          </div>
        </article>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <article class="panel">
          <p class="panel-heading">
            Template Lines
          </p>
          <div class="panel-block">
            <div class="control" style="width: 100%;">
              @if (Model.Lines && Model.Lines.length > 0) {
                <div>
                  @for (line of Model.Lines; track line; let i = $index) {
                    <div class="template-line-row mb-2">
                      <div class="field has-addons">
                        <p class="control">
                          <span class="button is-static">{{i + 1}}</span>
                        </p>
                        <p class="control">
                          <span class="button is-static" [title]="line.LineType === 'text' ? 'Text alignment' : 'Barcode line'">
                      <i class="fa" [ngClass]="{
                        'fa-align-left': line.LineType === 'text' && (line.Alignment === 0 || line.Alignment === undefined),
                        'fa-align-center': line.LineType === 'text' && line.Alignment === 1,
                        'fa-align-right': line.LineType === 'text' && line.Alignment === 2,
                        'fa-barcode': line.LineType === 'barcode'
                      }"></i>
                          </span>
                        </p>
                        <p class="control is-expanded">
                          @if (line.LineType === 'text') {
                            <span class="input is-static is-fullwidth"
                          [ngStyle]="{
                            'text-align': line.Alignment === 0 ? 'left' : line.Alignment === 1 ? 'center' : 'right',
                            'white-space': 'pre-wrap'
                          }" 
                            [innerHTML]="formatText(line.Content)"></span>
                          }
                          @if (line.LineType === 'barcode') {
                            <span class="input is-static is-fullwidth">
                              <span class="mr-2">{{line.Content}}</span>
                              <span class="tag is-info is-light mr-2">{{getBarcodeTypeName(line.BarcodeType)}}</span>
                              <span class="tag is-info is-light mr-2">{{line.Orientation}}</span>
                              <span class="tag is-info is-light mr-2">Width: {{line.Width}}px</span>
                              <span class="tag is-info is-light">Height: {{line.Height}}px</span>
                            </span>
                          }
                        </p>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (!Model.Lines || Model.Lines.length === 0) {
                <div class="notification is-warning">
                  No template lines defined.
                </div>
              }
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
}